/**
 * @author: Shivani mehra
 */
import React, { useState, useEffect, useCallback } from "react";
import { Col, Container, Row, Button, Form, Card } from "react-bootstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { CFormCheck, CListGroup, CListGroupItem } from "@coreui/react";

const AddInvoice = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [planById, setPlanById] = useState({});
  const [planById2, setPlanById2] = useState({});
  const [company, setCompany] = useState({});
  const [selectOption, setSelectOption] = useState({
    user: true,
    amount: true,
  });

  const [radioError, setRadioError] = useState({
    user: "",
    amount: "",
  });

  const [invoice, setInvoice] = useState({
    company_id: "",
    tenantcode: "",
    user_id: "",
    plan_id: "",
    plan_name: "",
    subscription_id: "",
    amount: "",
    validity: "",
    date: "",
    payment_method: "",
    new_name: "",
    transaction_cheque_no: "",
    order_id: "",
    user: "old_user",
  });

  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const [availableAddons, setAvailableAddons] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);

  // var previousMonthStudentAddmissionCount = 0;
  useEffect(() => {
    var id;
    if (location.hasOwnProperty("pathname")) {
      id = location.pathname.split("/")[3];
    }
    fetchAddons();
    init(id, props?.action);
  }, []);

  const init = async (id, action) => {
    if (action === "pay") {
      const response = await WhatsAppAPI.fetchCompanyAndUserByInvoice(id);
      setCompany(response[0].company);
      setInvoice({
        ...response[0].invoice,
        user: "old_user",
      });
      setSelectOption({ user: true, amount: true });
      setRadioError({ user: "", amount: "" });

      if (response[0].invoice.plan_id) {
        const plan = await WhatsAppAPI.getPlansById(
          response[0].invoice.plan_id,
        );
        if (plan) {
          setPlanById(plan);
        }
      }
    } else {
      const response = await WhatsAppAPI.findCompanyWithUser(id);
      if (response) {
        setCompany(response.companyResult[0]);
        setSelectOption({ user: true, amount: true });
        setRadioError({ user: "", amount: "" });

        setInvoice((prev) => ({
          ...prev,
          user_id: response.companyResult[0]?.user_id,
          amount: response.companyResult[0]?.amount,
          company_id: response.companyResult[0]?.company_id,
          date: response.companyResult[0]?.invoice_date,
          plan_name: response.companyResult[0]?.plan_name,
          validity: response.companyResult[0]?.validity,
          plan_id: response.companyResult[0]?.plan_id,
          number_of_users: response.companyResult[0]?.number_of_users,
          number_of_whatsapp_setting:
            response.companyResult[0]?.number_of_whatsapp_setting,
          user: "old_user",
        }));
      } else {
        setCompany({});
      }
    }
    const plansResult = await WhatsAppAPI.getPlanData("active");
    if (plansResult.success) {
      setPlans(plansResult.records);
    } else {
      setPlans([]);
    }
  };

  const fetchPlanById = async (id) => {
    if (id) {
      const record = await WhatsAppAPI.getPlansById(id);
      if (record) {
        setPlanById(record);
        setInvoice({ ...invoice, plan_id: id });
        let amt = document.querySelectorAll("#amount");
        amt[0].checked = false;
        amt[1].checked = false;
      }
    }
  };

  //handle change
  const handleChange = async (e) => {
    if (e.target.name === "user") {
      const isNewUser = e.target.value === "new_user_name";
      let anotherName = document.getElementById("another-name");
      if (anotherName) {
        if (isNewUser) {
          anotherName.removeAttribute("disabled");
        } else {
          anotherName.setAttribute("disabled", true);
        }
      }
      setRadioError((prev) => ({ ...prev, user: "" }));
      setSelectOption((prev) => ({ ...prev, user: true }));
      setInvoice((prev) => ({
        ...prev,
        user: e.target.value,
        user_id: company.user_id,
        new_name: isNewUser ? prev.new_name : "",
      }));
    } else if (e.target.name === "amount") {
      setSelectOption((prev) => ({ ...prev, amount: true }));
      setRadioError((prev) => ({ ...prev, amount: "" }));
      setInvoice((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        validity: e.target.getAttribute("data-validity"),
      }));
    } else if (e.target.name === "plan") {
      const planid = e.target.value;
      let planname =
        e.target[e.target.selectedIndex].getAttribute("data-planname");
      if (planid) {
        setInvoice((prev) => ({ ...prev, plan_name: planname, plan_id: planid }));
        fetchPlanById(planid);
        if (planname.toLowerCase() === "free") {
          document.getElementById("payment_method")?.removeAttribute("required");
          setSelectOption((prev) => ({ ...prev, amount: true }));
        } else {
          document
            .getElementById("payment_method")
            ?.setAttribute("required", true);
        }
      } else {
        setPlanById({});
      }
    } else {
      const { name, value } = e.target;
      setInvoice((prev) => {
        const updated = { ...prev, [name]: value };
        if (name === "payment_method") {
          if (value === "cheque") {
            const trCqDiv = document.getElementById("tr_cq_div");
            if (trCqDiv) trCqDiv.style.display = "block";
            document
              .getElementById("transaction_cheque_no")
              ?.setAttribute("required", true);
          } else {
            const trCqDiv = document.getElementById("tr_cq_div");
            if (trCqDiv) trCqDiv.style.display = "none";
            document
              .getElementById("transaction_cheque_no")
              ?.removeAttribute("required");
            updated.transaction_cheque_no = "";
          }
        }
        return updated;
      });
    }
    // Defer validation slightly to allow state to propagate
    setTimeout(() => {
      validateForm();
    }, 0);
  };

  const handleSubmit = async (updatedInvoice) => {
    // e.preventDefault();
    if (!validateForm()) {
      return false;
    }
    setIsLoading(true);

    updatedInvoice.company_id = company.company_id;
    updatedInvoice.tenantcode = company.tenantcode;
    updatedInvoice.company = company;
    if (updatedInvoice?.id) {
      const response =
        await WhatsAppAPI.updateInvoiceAddTransaction(updatedInvoice);
      if (response.success) {
        setIsLoading(false);
        toast.success("Invoice Updated Successfully!");
        toast.success("Transaction Created Successfully!");
        navigate("/company/" + company.company_id);
      } else {
        setIsLoading(false);
        toast.error(response.message);
      }
    } else {
      const response =
        await WhatsAppAPI.addInvoiceWithTransaction(updatedInvoice);
      if (response.success) {
        setIsLoading(false);
        toast.success("Invoice Created Successfully!");
        navigate("/company/" + company.company_id);
      } else {
        setIsLoading(false);
        toast.error(response.message);
      }
    }
  };

  const validateForm = () => {
    let isValid = true;
    const validateInputs = document.querySelectorAll("input, select");
    validateInputs.forEach((validateInput) => {
      validateInput.classList.remove("warning");
      validateInput.classList.remove("error");
      if (validateInput.hasAttribute("required")) {
        if (validateInput.value.trim().length === 0) {
          isValid = false;
          validateInput.classList.add("warning");
          validateInput.classList.add("error");
        }
      }
    });

    if (!selectOption.user && props?.action === "pay") {
      isValid = false;
      setRadioError((prev) => ({ ...prev, user: "Please select an option." }));
    }

    setIsFormValid(isValid);

    return isValid;
  };

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const onlinePayment = useCallback(async () => {
    if (!validateForm()) {
      return false;
    }

    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js",
    );

    if (!res) {
      alert("Razropay failed to load!!");
      return;
    }

    const obj = { amount: invoice.amount };
    const data = await WhatsAppAPI.getRazorPayData(obj);
    //    console.log('OP Result: ', data);
    const options = {
      key: "rzp_test_dgYSDQuilJnxen",
      amount: invoice.amount * 100,
      currency: "INR",
      name: "Acme Corp",
      description: "Test Transaction",
      image: "https://example.com/your_logo",
      order_id: data.records.id,
      //callback_url: "http://localhost:1769/verify",
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
      handler: async (response) => {
        //    console.log('OP Response: ', response, data);
        try {
          // const paymentData = {
          //   order_id: response.order_id,
          //   payment_id: response.razorpay_payment_id,
          //   signature: response.razorpay_signature,
          //   student_addmission_id: studentRecord?.student_addmission_id,
          //   amount: data.amount,
          //   payment_date: new Date(),
          //   payment_method: "Online (Razorpay)",
          //   transaction_no: response.razorpay_payment_id,
          //   status: "Success",
          // };

          if (response.razorpay_payment_id) {
            //   feeDeposit.payment_method = "razorpay";
            //   feeDeposit.transaction_no = response.razorpay_payment_id;
            const updatedInvoice = {
              ...invoice,
              payment_method: "Online (Razorpay)",
              transaction_cheque_no: response.razorpay_payment_id,
              order_id: response.razorpay_order_id,
              signature: response.razorpay_signature,
            };

            setInvoice(updatedInvoice);
            await handleSubmit(updatedInvoice);
          } else {
            toast.error("payment not acctepable");
          }
        } catch (error) {
          toast.error("Something went wrong while saving payment.");
        }
      },
      prefill: {
        name: company?.firstname + " " + company?.lastname,
        email: company?.email,
        contact: company?.whatsapp_number,
      },
      modal: {
        ondismiss: function () {},
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }, [isPaymentProcessing, invoice]);

  // async function onlinePayment() {
  //     const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

  //     if (!res) {
  //         alert("Razropay failed to load!!");
  //         return;
  //     }

  //     const obj = { amount: 2 }
  //     const data = await WhatsAppAPI.getRazorPayData(obj);
  // //    console.log('OP Result: ', data);
  //     const options = {
  //         key: "rzp_test_dgYSDQuilJnxen",
  //         amount: data.amount,
  //         currency: "INR",
  //         name: "Acme Corp",
  //         description: "Test Transaction",
  //         image: "https://example.com/your_logo",
  //         order_id: data.id,
  //         //callback_url: "http://localhost:1769/verify",
  //         notes: {
  //             address: "Razorpay Corporate Office",
  //         },
  //         theme: {
  //             color: "#3399cc",
  //         },
  //         handler: async function (response) {
  //         //    console.log('OP Response: ', response);
  //           try {
  //             const paymentData = {
  //               order_id: response.order_id,
  //               payment_id: response.razorpay_payment_id,
  //               signature: response.razorpay_signature,
  //             //   student_addmission_id: studentRecord?.student_addmission_id,
  //               amount: data.amount,
  //               payment_date: new Date(),
  //               payment_method: "Online (Razorpay)",
  //               transaction_no: response.razorpay_payment_id,
  //               status: "Success",
  //             };
  //             if (response.razorpay_payment_id) {
  //             //   feeDeposit.payment_method = "razorpay";
  //             //   feeDeposit.transaction_no = response.razorpay_payment_id;
  //                 // handleSubmit();
  //             } else {
  //               toast.error("payment not acctepable");
  //             }
  //           } catch (error) {
  //             toast.error("Something went wrong while saving payment.");
  //           }
  //         },
  //         prefill: {
  //           name: "Abhishek Sharma",
  //           email: "contact@watconnect.com",
  //           contact: "9876543210",
  //         },
  //         modal: {
  //           ondismiss: function () {

  //           },
  //         },
  //     };

  //     const paymentObject = new window.Razorpay(options);
  //     paymentObject.on('payment.failed', function (response){
  //         alert(response.error.code);
  //         alert(response.error.description);
  //         alert(response.error.source);
  //         alert(response.error.step);
  //         alert(response.error.reason);
  //         alert(response.error.metadata.order_id);
  //         alert(response.error.metadata.payment_id);
  //     });
  //     paymentObject.open();
  // }

  const fetchAddons = async () => {
    try {
      const response = await WhatsAppAPI.getAllAddons();
      if (response.success) {
        setAvailableAddons(response.records);
      }
    } catch (error) {
      //   console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (planById?.addons && invoice.subscription_id) {
      const filteredAddons = planById.addons.filter(
        (addon) => addon.subscription_id === invoice.subscription_id,
      );
      if (props?.action === "pay") {
        setSelectedAddons(filteredAddons);
      }
    }
    // else if (company?.addons && company?.subscription_id) {
    //   const filteredAddons = company.addons.filter(
    //     (addon) => addon.subscription_id === company.subscription_id
    //   );
    //   setSelectedAddons(filteredAddons);
    // }
  }, [planById, invoice.subscription_id, company]);

  const handleAddonQuantityChange = (e, addonId) => {
    const newQuantity = parseInt(e.target.value, 10);
    if (newQuantity < 1) return;
    setSelectedAddons((prev) =>
      prev.map((a) =>
        a.addon_id === addonId ? { ...a, quantity: newQuantity } : a,
      ),
    );
  };

  const handleAddonCheckChange = (e, addon, proratedPrice) => {
    if (e.target.checked) {
      let price = proratedPrice;
      setSelectedAddons((prev) => {
        if (!prev.find((a) => a.addon_id === addon.id)) {
          return [
            ...prev,
            {
              addon_id: addon.id,
              quantity: 1,
              unit_price: price,
            },
          ];
        }
        return prev;
      });
    } else {
      setSelectedAddons((prev) => prev.filter((a) => a.addon_id !== addon.id));
    }
  };

  const handleGenerateInvoice = async (invoice) => {
    if (!validateForm()) {
      return false;
    }
    setIsLoading(true);

    const addonSummary = selectedAddons.map((selected) => {
      const total_price = selected.unit_price * selected.quantity;

      return {
        addon_id: selected.addon_id,
        quantity: selected.quantity,
        unit_price: Number(selected.unit_price),
        total_price: Number(total_price),
        subscription_id: company.subscription_id,
        type: "addon",
        plan_id: company.plan_id,
        status: "Complete",
        start_date: company.start_date,
        end_date: company.end_date,
      };
    });

    const addonTotal = addonSummary.reduce(
      (acc, curr) => acc + curr.total_price,
      0,
    );

    const total_amount = (company.amount || 0) + addonTotal;
    const billing_amount =
      company.plan_status === "Pending"
        ? Math.round(total_amount)
        : Math.round(addonTotal);

    const finalPayload = {
      addons: addonSummary,
      total_amount: Math.round(total_amount),
      addonTotal: Math.round(addonTotal),
      invoice_id: company.invoice_id,
      transaction_cheque_no: "",
      order_id: "",
      payment_method: "cash",
      company: { ...company },
      plan_name: company.plan_name,
      billing_amount,
      subscription_id: company.subscription_id,
    };

    const response =
      await WhatsAppAPI.generateInvoiceAddTransaction(finalPayload);
    if (response.success) {
      setIsLoading(false);
      toast.success("Invoice Created Successfully!");
      navigate("/company/" + company.company_id);
    } else {
      setIsLoading(false);
      toast.error(response.message);
    }
  };

  return (
    <>
      <Container className="mt-5">
        <Row className="mx-5 text-center g-0">
          <Col lg={12} xs={12} sm={12}>
            <div
              className=" text-center p-2"
              style={{
                height: "40px",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
            >
              <span
                className="fw-semibold p-1"
                style={{ color: "#605C68", fontSize: "large" }}
              >
                Generate Invoice
              </span>
            </div>
          </Col>
        </Row>
      </Container>
      {isLoading ? (
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      ) : (
        <>
          <Container className="mt-1 mb-5">
            <Row className="view-form mb-4 g-0 mx-5">
              <Card>
                <Col lg={12}>
                  <Form noValidate>
                    <Row className="pb-4 mx-5 mt-5 border-bottom">
                      <Col lg={6} className="">
                        <p className="fs-5 fw-bold">Company Information:</p>
                        <p className="fs-4 fw-bold">{company?.company_name}</p>
                        <p className="fs-5 mb-0 fw-bold">Address:</p>
                        <p className="fs-6">
                          {company?.street && `${company.street},`}
                          <br />
                          {company?.city && `${company.city}, `}
                          {company?.state && `${company.state}, `}
                          {company?.country && company.country}
                          {company?.pincode && ` (${company.pincode})`}
                        </p>
                      </Col>
                      <Col lg={6}>
                        <p className="fs-5 fw-bold">User Information:</p>
                        <div className="d-flex flex-direction-column">
                          <div className="d-flex align-items-baseline">
                            <input
                              type="radio"
                              id="user_old"
                              name="user"
                              value="old_user"
                              style={{ marginRight: "15px" }}
                              onChange={handleChange}
                              checked={invoice.user === "old_user"}
                            />
                            <div>
                              <p className="fs-5 fw-bold">
                                {company?.firstname} {company?.lastname}
                              </p>
                              <p className="fs-5 mb-0 fw-bold">Email:</p>
                              <p className="fs-6">{company?.email}</p>
                              <p className="fs-5 mb-0 fw-bold">Contact:</p>
                              <p className="fs-6">{company?.whatsapp_number}</p>
                            </div>
                          </div>
                          <div className="d-flex align-items-baseline mt-2">
                            <input
                              type="radio"
                              id="user_new"
                              name="user"
                              value="new_user_name"
                              style={{ marginRight: "15px" }}
                              onChange={handleChange}
                              checked={invoice.user === "new_user_name"}
                            />
                            <Form.Control
                              type="text"
                              id={"another-name"}
                              placeholder="Another Users Name"
                              name={"new_name"}
                              style={{ width: "250px" }}
                              onChange={handleChange}
                              disabled
                            />
                          </div>
                        </div>
                        {radioError.user && (
                          <p
                            className="fw-bold fs-6 mt-3"
                            style={{ color: "red" }}
                          >
                            {radioError.user}
                          </p>
                        )}
                      </Col>
                    </Row>
                    <Row className="pb-4 mx-5 mt-5 border-bottom">
                      <Col lg={12}>
                        {invoice?.id ? (
                          <p className="fw-bold fs-5">
                            Invoice Number: {invoice.invoice_no}
                          </p>
                        ) : (
                          ""
                        )}
                      </Col>

                      <Col lg={3}>
                        <p className="fs-6 border-0 mt-3">
                          <strong>Plan Name :</strong>{" "}
                          {plans?.find(
                            (p) => p.plan_info.id === invoice?.plan_id,
                          )?.plan_info.name || "N/A"}
                        </p>
                        <p className="fs-6 border-0 mt-2">
                          <strong>Price :</strong>{" "}
                          {(() => {
                            const selectedPlan = plans?.find(
                              (p) => p.plan_info.id === invoice?.plan_id,
                            )?.plan_info;

                            if (!selectedPlan || !invoice?.validity)
                              return "--";

                            let priceLabel = "";
                            let priceValue = "";

                            switch (invoice.validity) {
                              case 1:
                                priceLabel = "Month";
                                priceValue = selectedPlan.price_per_month;
                                break;
                              case 3:
                                priceLabel = "Quarter";
                                priceValue = selectedPlan.price_per_quarterly;
                                break;
                              case 6:
                                priceLabel = "Half-Year";
                                priceValue = selectedPlan.price_per_half_yearly;
                                break;
                              case 12:
                                priceLabel = "Year";
                                priceValue = selectedPlan.price_per_year;
                                break;
                              default:
                                priceLabel = "";
                                priceValue = "--";
                            }

                            return `₹ ${priceValue} / ${priceLabel}`;
                          })()}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <p className="fs-6 fw-bold border-0 mt-3">
                          Number of Users:{" "}
                          {planById?.number_of_users
                            ? planById?.number_of_users
                            : (invoice?.number_of_users ?? "0")}
                        </p>
                        <p className="fs-6 fw-bold border-0 mt-2">
                          Number of Whatsapp Setting:{" "}
                          {planById?.number_of_whatsapp_setting
                            ? planById?.number_of_users
                            : (invoice?.number_of_whatsapp_setting ?? "0")}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <p className="fs-6 border-0 mt-3">
                          <strong>Plan Start Date :</strong>{" "}
                          {moment(invoice.start_date).format("DD-MM-YYYY")}
                        </p>
                        <p className="fs-6 border-0 mt-2">
                          <strong>Plan End Date :</strong>{" "}
                          {moment(invoice.end_date).format("DD-MM-YYYY")}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <Form.Group className="my-3">
                          <Form.Label
                            className="form-view-label fw-bold fs-6"
                            htmlFor="formBasicFirstName"
                          >
                            Invoice Date
                          </Form.Label>
                          <Form.Control
                            required
                            type="date"
                            name="date"
                            style={{ width: "75%" }}
                            value={moment().format("YYYY-MM-DD")}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={12}>
                        {planById?.modules?.length > 0 && (
                          <div className="my-3">
                            <strong className="mt-4 mb-2">Modules</strong>
                            <Row className="mt-2">
                              {planById.modules.map((module, index) => (
                                <Col md={4} key={module.id}>
                                  <i className="fa fa-tasks mx-2"></i>
                                  {module.name}
                                </Col>
                              ))}
                            </Row>
                          </div>
                        )}
                      </Col>
                      <Col lg={6}>
                      </Col>
                      {availableAddons.length > 0 && (
                        <Col lg={12} className="mt-4">
                          {props?.action === "pay" ? (
                            <>
                              {selectedAddons?.length > 0 && (
                                <strong className="mt-5 ">Addon Plans :</strong>
                              )}
                              <Col lg={12}>
                                {availableAddons?.length > 0 && (
                                  <div className="my-2">
                                    <Row className="mt-2">
                                      {selectedAddons?.map((selectedAddon) => {
                                        const addonDetails =
                                          availableAddons.find(
                                            (addon) =>
                                              addon.id ===
                                              selectedAddon.addon_id,
                                          );
                                        const quantityValue =
                                          selectedAddon.quantity || 0;

                                        if (!addonDetails) return null;

                                        return (
                                          <Col
                                            md={4}
                                            key={selectedAddon.addon_id}
                                          >
                                            <i className="fa fa-tasks mx-2"></i>
                                            {addonDetails.name} ({quantityValue}
                                            )
                                          </Col>
                                        );
                                      })}
                                    </Row>
                                  </div>
                                )}
                              </Col>
                            </>
                          ) : (
                            <>
                              <strong className="mt-5 mb-2">
                                Addon Plans :
                              </strong>
                              <div
                                className="mt-3"
                                style={{
                                  maxHeight: "138px",
                                  overflowY: "auto",
                                }}
                              >
                                <CListGroup>
                                  {availableAddons?.map((addon) => {
                                    const selectedAddon = selectedAddons.find(
                                      (sa) => sa.addon_id === addon.id,
                                    );
                                    let fullPrice = 0;
                                    if (company.validity === 1)
                                      fullPrice = addon.monthly;
                                    else if (company.validity === 3)
                                      fullPrice = addon.quarterly;
                                    else if (company.validity === 6)
                                      fullPrice = addon.half_yearly;
                                    else if (company.validity === 12)
                                      fullPrice = addon.yearly;

                                    const usedMonths = moment().diff(
                                      moment(company.start_date),
                                      "months",
                                    );
                                    const remainingMonths =
                                      company.validity - usedMonths;

                                    const pricePerMonth =
                                      fullPrice / company.validity;
                                    const proratedPrice =
                                      pricePerMonth * remainingMonths;

                                    const isChecked = !!selectedAddon;
                                    const quantityValue =
                                      selectedAddon?.quantity || 0;
                                    return (
                                      <CListGroupItem
                                        key={addon.id}
                                        className="d-flex align-items-center justify-content-between"
                                        style={{ gap: "10px" }}
                                      >
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ flexBasis: "30%" }}
                                        >
                                          <CFormCheck
                                            id={`addon-${addon.id}`}
                                            label={addon.name}
                                            checked={isChecked}
                                            onChange={(e) =>
                                              handleAddonCheckChange(
                                                e,
                                                addon,
                                                proratedPrice,
                                              )
                                            }
                                          />
                                        </div>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ flexBasis: "30%" }}
                                        >
                                          {(() => {
                                            const startDate = new Date(
                                              company.start_date,
                                            );
                                            const today = new Date();

                                            const isSameMonth =
                                              startDate.getMonth() ===
                                                today.getMonth() &&
                                              startDate.getFullYear() ===
                                                today.getFullYear();

                                            return company.validity !== 1 &&
                                              !isSameMonth ? (
                                              <>
                                                <span
                                                  className="text-decoration-line-through"
                                                  style={{
                                                    borderBottom: "0px",
                                                  }}
                                                >
                                                  ₹{fullPrice}
                                                </span>
                                                &nbsp;
                                              </>
                                            ) : null;
                                          })()}
                                          ₹{Math.round(proratedPrice)}
                                        </div>
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ flexBasis: "20%" }}
                                        >
                                          <label
                                            htmlFor={`qty-${addon.id}`}
                                            className="me-2 mb-0"
                                          >
                                            Quantity:
                                          </label>
                                          <input
                                            id={`qty-${addon.id}`}
                                            type="number"
                                            min="1"
                                            step="1"
                                            pattern="[1-9][0-9]*"
                                            value={quantityValue}
                                            className="form-control form-control-sm "
                                            style={{ width: "60px" }}
                                            onChange={(e) =>
                                              handleAddonQuantityChange(
                                                e,
                                                addon.id,
                                              )
                                            }
                                            onBlur={(e) => {
                                              if (
                                                !e.target.value ||
                                                +e.target.value < 1
                                              ) {
                                                e.target.value = 1;
                                                handleAddonQuantityChange(
                                                  e,
                                                  addon.id,
                                                );
                                              }
                                            }}
                                            disabled={!isChecked}
                                          />
                                        </div>

                                        <div
                                          className="d-flex align-items-center"
                                          style={{
                                            marginLeft: "auto",
                                            textAlign: "center",
                                            width: "80px",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          ₹
                                          {Math.round(
                                            proratedPrice * quantityValue,
                                          )}
                                        </div>
                                      </CListGroupItem>
                                    );
                                  })}
                                </CListGroup>
                              </div>
                            </>
                          )}
                        </Col>
                      )}
                    </Row>
                    <Row className="pb-4 mx-5 mt-5">
                      <Col lg={4}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label fw-bold fs-6"
                            htmlFor="payment_method"
                          >
                            Payment Mode
                          </Form.Label>
                          <Form.Select
                            required
                            id="payment_method"
                            name="payment_method"
                            style={{ width: "75%" }}
                            value={invoice?.payment_method}
                            onChange={handleChange}
                          >
                            <option value="">None</option>
                            <option value="cash">Cash</option>
                            <option value="upi">UPI</option>
                            <option value="cheque">Cheque</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg={4} id="tr_cq_div" style={{ display: "none" }}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label fw-bold fs-6"
                            htmlFor="transaction_cheque_no"
                          >
                            Transaction No./Cheque No.
                          </Form.Label>
                          <Form.Control
                            id="transaction_cheque_no"
                            type="text"
                            name="transaction_cheque_no"
                            onChange={handleChange}
                            value={
                              invoice?.transaction_cheque_no !== ""
                                ? invoice?.transaction_cheque_no
                                : ""
                            }
                            style={{ width: "75%" }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="pb-4 mx-5 mt-3 justify-content-end">
                      <Col lg={3} className="text-end">
                        <Button
                          variant="light"
                          className="me-3"
                          onClick={() =>
                            navigate("/company/" + company.company_id)
                          }
                        >
                          Cancel
                        </Button>
                        {/* <Button variant='primary' onClick={onlinePayment} disabled={!isFormValid}>Procced</Button> */}
                        {props?.action === "pay" ? (
                          <Button
                            variant="primary"
                            onClick={() => {
                              if (invoice?.payment_method === "upi") {
                                onlinePayment();
                              } else if (
                                invoice?.payment_method === "cash" ||
                                invoice?.payment_method === "cheque"
                              ) {
                                handleSubmit(invoice);
                              } else {
                                console.error(
                                  "Invalid payment method selected",
                                );
                              }
                            }}
                            disabled={!isFormValid || isLoading}
                          >
                            {" "}
                            Proceed{" "}
                          </Button>
                        ) : (
                          <Button
                            variant="primary"
                            onClick={() => handleGenerateInvoice(invoice)}
                            disabled={
                              !isFormValid ||
                              isLoading ||
                              selectedAddons.length === 0
                            }
                          >
                            Generate Invoice
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Card>
            </Row>
          </Container>
        </>
      )}

      <ToastContainer autoClose={30000} />
    </>
  );
};

export default AddInvoice;
